import { render, staticRenderFns } from "./EmployeesTable.vue?vue&type=template&id=5952ffdf&"
import script from "./EmployeesTable.vue?vue&type=script&lang=js&"
export * from "./EmployeesTable.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports